module.exports = __webpack_public_path__ + "img/Miller-High-Life-Bottle.06e2d952.png";